import { Alert, Input, Modal, Space, Typography } from 'antd'
import { useEffect, useState } from 'react'

import { diskErrorText } from '@/Containers/DiskSection/DiskContainer/Hooks'

import { RequestDiskCleanupTask } from '../Tasks/RequestDiskCleanupTask'

/** Межа тексту прохання — та сама, що приймає бек (`RequestDiskCleanupAction::MESSAGE_MAX`). */
export const CLEANUP_MESSAGE_MAX_LENGTH = 1000

interface CleanupRequestModalProps {
    open: boolean
    storageUuid: string
    ownerName: string
    onClose: () => void
    onSent: () => void
}

/**
 * «Попросити звільнити місце» (`DISK-006` §2.2): адміністратор не бачить
 * складу активного «Мого диска», тож прибирає власник. Бек надсилає йому
 * сповіщення «Звільніть місце на диску» з необов'язковим повідомленням і
 * пише прохання в журнал адміністратора.
 */
export const CleanupRequestModal = ({ open, storageUuid, ownerName, onClose, onSent }: CleanupRequestModalProps) => {
    const [message, setMessage] = useState('')
    const [sending, setSending] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        if (open) {
            setMessage('')
            setError(null)
        }
    }, [open])

    const send = async () => {
        setSending(true)
        setError(null)

        try {
            await RequestDiskCleanupTask(storageUuid, message)
            onSent()
        } catch (failure) {
            setError(diskErrorText(failure, 'Не вдалося надіслати прохання'))
        } finally {
            setSending(false)
        }
    }

    return (
        <Modal
            open={open}
            title="Попросити звільнити місце"
            okText="Надіслати"
            cancelText="Скасувати"
            confirmLoading={sending}
            onOk={() => void send()}
            onCancel={onClose}
            destroyOnHidden
        >
            <Space orientation="vertical" size={12} style={{ width: '100%' }}>
                <Typography.Text>
                    {ownerName} отримає сповіщення з проханням прибрати непотрібне на своєму диску.
                </Typography.Text>
                <Input.TextArea
                    aria-label="Повідомлення"
                    placeholder="Повідомлення (необов’язково)"
                    autoSize={{ minRows: 3, maxRows: 6 }}
                    maxLength={CLEANUP_MESSAGE_MAX_LENGTH}
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                />
                {error !== null ? <Alert type="error" showIcon title={error} /> : null}
            </Space>
        </Modal>
    )
}
